import React, { useEffect, useState } from "react";
import styles from './PasswordField.module.scss';
import PropTypes from "prop-types";
import TextField from "../textField/TextField";

const PasswordField = ({
  label,
  placeholder,
  value,
  onChange,
  disabled = false,
  error,
  showPassword = false,
}) => {
  const [passwordValue, setPasswordValue] = useState('');
  const [strength, setStrength] = useState('Weak');
  const [iconType, setIconType] = useState('error');
  const [minLength, setMinLength] = useState(false);
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialCharacter, setHasSpecialCharacter] = useState(false);

  useEffect(() => {
    setPasswordValue(value || '')
  }, [value]);

  const handleChange = (value) => {
    let passedCount = 0;
    if(value.length >= 8) {
      setMinLength(true);
      passedCount++;
    } else {
      setMinLength(false);
    }
    if(/[a-z]/.test(value)) {
      setHasLowerCase(true);
      passedCount++;
    } else {
      setHasLowerCase(false);
    }
    if(/[A-Z]/.test(value)) {
      setHasUpperCase(true);
      passedCount++;
    } else {
      setHasUpperCase(false);
    }
    if(/\d/.test(value)) {
      setHasNumber(true);
      passedCount++;
    } else {
      setHasNumber(false);
    }
    if(/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
      setHasSpecialCharacter(true);
      passedCount++;
    } else {
      setHasSpecialCharacter(false);
    }

    switch(passedCount) {
      case 1:
      case 2: setStrength('Weak');break;
      case 3:
      case 4: setStrength('Medium');break;
      case 5: setStrength('Strong');break;
      default: setStrength('Weak');
    }

    setIconType(passedCount >= 5 ? 'success' : 'error');

    setPasswordValue(value);
    onChange(value, passedCount < 5);
  }

  return (
    <div className={styles.password}>
      <div className={styles.inputBox}>
        <TextField
          label={label}
          type={showPassword ? 'text' : 'password'}
          placeholder={placeholder}
          value={passwordValue}
          onChange={handleChange}
          disabled={disabled}
          error={error}
        />
        { passwordValue && <span className={`${styles.strength} ${styles[strength]}`}>{strength}</span> }
      </div>
      { passwordValue && <div className={styles.validation}>
        <span className={`${styles.icon} ${styles[iconType]}`}></span>
        <div className={styles.message}>
          <span className={minLength ? styles.success : ''}>Min. 8 character, </span>
          <span className={hasUpperCase ? styles.success : ''}>1 uppercase letter, </span>
          <span className={hasLowerCase ? styles.success : ''}>1 lowercase letter, </span>
          <span className={hasNumber ? styles.success : ''}>1 number</span>
          <span className={hasNumber && hasSpecialCharacter ? styles.success : ''}>and </span>
          <span className={hasSpecialCharacter ? styles.success : ''}>1 special character, </span>
        </div> 
      </div> }
    </div>
  );
};

PasswordField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  showPassword: PropTypes.bool
};

export default PasswordField;
